/**
 * useListExport — Exportação de uma lista importada (Central de Listas)
 * -----------------------------------------------------------------------------
 * Encapsula a permissão de exportação e o modal genérico, para que cada aba da
 * Central de Listas precise apenas de um item de menu "Exportar lista".
 *
 * Uso:
 *   const { podeExportar, exportarLista, dialogoExportacao } = useListExport('lists_deals');
 *   ...
 *   {podeExportar && <DropdownMenuItem onClick={() => exportarLista({ refId: j.id, name: j.name })}>...}
 *   ...
 *   {dialogoExportacao}
 *
 * @version 1.0.0
 * RELEASE: 2026-09-12 v1.0.0 - Criação inicial.
 */

import { useState } from 'react';

import { ExportDialog } from './ExportDialog';
import { useMyExportPermissions } from '@/hooks/useExportPermissions';
import type { ListsExportParams } from '@/lib/export/sources/listsSource';

export function useListExport(sourceId: string) {
  const { getPermission, loading } = useMyExportPermissions();
  const permissao = getPermission(sourceId);

  /** Lista/importação selecionada para exportação (null = modal fechado) */
  const [alvo, setAlvo] = useState<ListsExportParams | null>(null);

  /** Só oferece a ação quando há alguma forma de entrega liberada no perfil */
  const podeExportar = !loading && (permissao.canDownload || permissao.canEmail);

  const dialogoExportacao = alvo ? (
    <ExportDialog
      open
      onOpenChange={(aberto) => {
        if (!aberto) setAlvo(null);
      }}
      sourceId={sourceId}
      params={alvo}
      fileNameHint={alvo.name}
    />
  ) : null;

  return { podeExportar, exportarLista: setAlvo, dialogoExportacao };
}
